export default "__VITE_ASSET__eb15b46b__"